/**
 * 全局常量、方法封装模块
 * 通过原型挂载到Vue属性
 * 通过 this.global 调用
 */

// 后台管理系统服务器地址
export const baseUrl = 'http://127.0.0.1:6070/api'


// cookie token名
export const cookieToken = 'Authorization'

// 上下文路径  history打包使用
export const contextPath = "/"

// 路由模式
export const routerMode = "history" // hash|history


export default {
  baseUrl,
  cookieToken,
  contextPath,
  routerMode
}



// WEBPACK FOOTER //
// ./src/utils/global.js